import { render, staticRenderFns } from "./ItemLocationModal.vue?vue&type=template&id=5cf4122e&scoped=true"
import script from "./ItemLocationModal.vue?vue&type=script&lang=js"
export * from "./ItemLocationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf4122e",
  null
  
)

export default component.exports